import { createFileRoute } from '@tanstack/react-router';
import { ContractDetailRoute } from '@/pages/contracts/detail-route';

/** Deep link al dettaglio: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute('/referrer/_layout/contracts/_layout/$id')(
  {
    component: ContractDetailRouteComponent,
  }
);

function ContractDetailRouteComponent() {
  const { id } = Route.useParams();

  return <ContractDetailRoute contractId={id} />;
}
